export const track = (eventName, payload) => {
  if (eventName && payload) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(`buybox.${eventName}`, payload);
  }
};

export const setErrorEvents = (error) => {
  try {
    const errorModel = {
      category: {
        primaryCategory: 'error'
      },
      evenyInfo: {
        eventName: 'post page error',
        error: [
          {
            type: 'advisory',
            displayType: 'inline',
            pageSection: 'pip',
            code: 'Alert - PIP',
            ...error
          }
        ]
      }
    };
    if (!window?.digitalData?.event) {
      window.digitalData.event = [];
    }
    window.digitalData.event.push(errorModel);
  } catch (err) {
    console.log(err);
  }
};